import { render, staticRenderFns } from "./MGallery.vue?vue&type=template&id=5dbaea17"
import script from "./MGallery.vue?vue&type=script&lang=js"
export * from "./MGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports